var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./popup_dialog.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-8ca1244c\"}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./popup_dialog.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./vue_shared/components/popup_dialog.vue
// module id = ./vue_shared/components/popup_dialog.vue
// module chunks = common_vue